/* eslint-disable import/prefer-default-export */
export const RELATION_TYPE_OPTIONS = [
  {
    name: '본인',
    value: 'PATIENT'
  },
  {
    name: '주문자의 배우자',
    value: 'SPOUSE'
  },
  {
    name: '주문자의 자녀',
    value: 'CHILD'
  },
  {
    name: '주문자의 부모',
    value: 'PARENT'
  },
  {
    name: '기타',
    value: 'ETC'
  }
];

export const MEAL_CATEGORY_OPTIONS = [
  {
    name: (
      <>
        <div style={{ wordBreak: 'keep-all' }}>
          <strong>예, </strong>
          병원에서 권장한 식사 내용을 바탕으로 <br /> 식사하고 싶습니다.
        </div>
      </>
    ),
    value: '1'
  },
  {
    name: (
      <>
        <div style={{ wordBreak: 'keep-all' }}>
          <strong>아니오, </strong>
          진단 받은 내용이 없습니다. <br />
          일반 저염식을 원합니다.
        </div>
      </>
    ),
    value: '2'
  }
];

export const GENDER_OPTIONS = [
  {
    name: '남',
    value: 'M'
  },
  {
    name: '여',
    value: 'F'
  }
];

export const KIDNEY_STATUS = [
  {
    name: '1-3기',
    value: 'kidney_disease'
  },
  {
    name: '4-5기',
    value: 'chronic_kidney_disease'
  },
  {
    name: '투석(혈액)',
    value: 'hemo_dialysis'
  },
  {
    name: '모르겠어요.',
    value: 'customized_disease'
  }
];

export const SPECIFICS = [
  {
    name: '당뇨병',
    value: 'diabetes'
  },
  {
    name: '고혈압 / 이상지혈증',
    value: 'hypertension'
  },
  {
    name: '통풍(요산수치 증가)',
    value: 'gout'
  }
];

// 당뇨 영역
export const DIABETES_STATUS = [
  {
    name: '1형',
    value: 'DIABETES_TYPE1'
  },
  { name: '2형', value: 'DIABETES_TYPE2' },
  { name: '임신성', value: 'DIABETES_GDM' },
  { name: '모르겠어요', value: 'ETC' }
];

export const GDM_DIABETS_STATUS = [
  { name: '초기 (1~13주)', value: 'FIRST_TIMESTER' },
  { name: '중기(14~27주)', value: 'SECOND_TIMESTER' },
  { name: '후기(28~40주)', value: 'THIRD_TIMESTER' },
  { name: '수유기', value: 'LACTIFEROUS_PHASE' }
];

export const YES_OR_NO = [
  {
    name: '예',
    value: 'Y'
  },
  {
    name: '아니오',
    value: 'N'
  }
];
// 암 영역

export const CANCER_CATEGORY = [
  { name: '간암', value: 'LIVER_CANCER' },
  { name: '갑상선암', value: 'THYROID_CANCER' },
  { name: '대장암', value: 'COLORECTAL_CANCER' },
  { name: '유방암', value: 'BREAST_CANCER' },
  { name: '위암', value: 'STOMACH_CANCER' },
  { name: '자궁경부암', value: 'CERVICAL_CANCER' },
  { name: '폐암', value: 'LUNG_CANCER' },
  { name: '기타', value: 'ETC' }
];

export const ANOTHER_DISEASE = [
  { name: '간질환', value: 'liverDisease', selected: false },

  { name: '고혈압', value: 'hypertension', selected: false },
  { name: '고콜레스테롤혈증', value: 'Hypercholesterolemia', selected: false },
  { name: '고중성지방혈증', value: 'Hypertriglyceridemia', selected: false },
  { name: '골다공증', value: 'Osteoporosis', selected: false },
  {
    name: '당뇨병',
    value: 'diabetes',
    selected: false
  },
  { name: '기타', value: 'etc', selected: false },
  { name: '없음', value: 'none', selected: false }
];

export const KIDNEY_CAUSES = [
  { name: '건강관리', value: 'healthcare', selected: false },
  { name: '고혈압', value: 'hypertension', selected: false },
  { name: '메니에르병', value: 'Meniere', selected: false },
  { name: '심혈관질환', value: 'cardiovascular', selected: false },
  { name: '간질환', value: 'liverDisease', selected: false },
  { name: '기타', value: 'etc', selected: false }
];

export const KIND_KIDNEY = [{ name: '투석', value: 'hemo_dialysis' }, { name: '비투석', value: 'none_hemo_dialysis' }, { name: '염분조절', value: 'kd_lowsalt' }];
export const KIND_KIDNEY_TRIAL = [{ name: '투석', value: 'hemo_dialysis_trial' }, { name: '비투석', value: 'none_hemo_dialysis_trial' }, { name: '염분조절', value: 'kd_lowsalt_trial' }];

export const NONE_DIALYSIS_OR_LOWSALT = [{ name: '비투석', value: 'none_hemo_dialysis' }, { name: '염분 조절', value: 'low_salt' }];
